<template>
  <div class="PageAccess">PageAccess</div>
</template>

<script>
export default {

}
</script>

<style>

</style>